/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @type {string} Artist action types.
 */

export const SET_LOADING = '[RECRUITER_ARTIST] SET_LOADING';
export const SET_SHOWCASE_ARTISTS_LIST = '[RECRUITER_ARTIST] SET_SHOWCASE_ARTISTS_LIST';
export const APPEND_SHOWCASE_ARTISTS_LIST = '[RECRUITER_ARTIST] APPEND_SHOWCASE_ARTISTS_LIST';
export const SET_SHOWCASE_ARTISTS_LIST_META = '[RECRUITER_ARTIST] SET_SHOWCASE_ARTISTS_LIST_META';

export const SET_FAVORITE_ARTISTS_LIST = '[RECRUITER_ARTIST] SET_FAVORITE_ARTISTS_LIST';
export const APPEND_FAVORITE_ARTISTS_LIST = '[RECRUITER_ARTIST] APPEND_FAVORITE_ARTISTS_LIST';
export const SET_FAVORITE_ARTISTS_LIST_META = '[RECRUITER_ARTIST] SET_FAVORITE_ARTISTS_LIST_META';

export const SET_ARTIST_SELECTED = '[RECRUITER_ARTIST] SET_ARTIST_SELECTED';
export const SET_ARTIST_SELECTED_META = '[RECRUITER_ARTIST] SET_ARTIST_SELECTED_META';

export const SET_ARTIST_SHOW_MEDIA = '[RECRUITER_ARTIST] SET_ARTIST_SHOW_MEDIA';
export const SET_ARTIST_WORKDONE_LIST = '[RECRUITER_ARTIST] SET_ARTIST_WORKDONE_LIST';
export const SET_ARTIST_NOTES_LIST = '[RECRUITER_ARTIST] SET_ARTIST_NOTES_LIST';
export const SET_SELECTED_ARTISTS = '[RECRUITER_ARTIST] SET_SELECTED_ARTISTS';
export const SET_IS_SELECT_MODE = '[RECRUITER_ARTIST] SET_IS_SELECT_MODE';
export const SET_LIST_TYPE = '[RECRUITER_ARTIST] SET_LIST_TYPE';

